export const getMatches = (state) => state.predictor?.matches;
export const getGroups = (state) => state.predictor?.groups;
export const getMatchById = (state, id) => state.predictior?.matches.find((match) => match.id === id);
export const getMarkets = (state) => state.predictor?.markets;
export const getUserPredictions = (state) => state.predictor?.predictions?.map((prediction) => prediction.fixtures[0]);
export const getMatchesSummary = (state) => state.predictor?.summary;
export const getMatchScorePredictions = (state, matchId) =>
	state.predictor?.summary?.find((matchSummary) => matchSummary.matchId === matchId)?.predictions.correctScore;
export const getRules = (state) => state.predictor?.rules;
